/**
 * Row of clickable question-number pills for jumping to any question in the test.
 * Disabled when proctor camera is off (blocks navigation in the candidate page).
 */
export default function QuestionNav({ questions, currentQ, answers, onSelect, disabled = false }) {
  return (
    <div className="flex flex-wrap gap-1.5 mb-6" data-testid="question-nav-pills">
      {questions.map((q, i) => {
        const isCurrent = i === currentQ;
        const isAnswered = !!answers[String(i)];
        const baseClass = "w-8 h-8 rounded-lg text-xs font-medium flex items-center justify-center transition-colors";
        let variantClass = "bg-secondary text-muted-foreground hover:bg-secondary/80";
        if (disabled) variantClass = "opacity-40 cursor-not-allowed";
        else if (isCurrent) variantClass = "bg-primary text-primary-foreground";
        else if (isAnswered) variantClass = "bg-[hsl(var(--success))]/15 text-[hsl(var(--success))] border border-[hsl(var(--success))]/25";

        return (
          <button
            key={q.id || `nav-q-${i}`}
            onClick={() => onSelect(i)}
            disabled={disabled}
            className={`${baseClass} ${variantClass}`}
            data-testid={`question-nav-${i}`}
          >
            {i + 1}
          </button>
        );
      })}
    </div>
  );
}
